import React, { Component } from "react";
import { Sidebarc } from "../Sidebar";
import { Appheaderc } from "../Appheader";
import { Button, Grid2, Paper, Typography } from "@mui/material";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import AddIcon from '@mui/icons-material/FormatListNumbered';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import {
  Tooltip,
  IconButton,
  TableBody,
  Table,
  Modal,
  MenuItem,
  TableContainer,
  TablePagination,
  Divider,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import base_url from "../baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const drawerWidth = 240;

class AddProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product_name: "",
      product_description: "",
      weight: "",
      metal_type: "",
      product_type: "",
      thumb_nail_img: "",
      price : 0,

      productImage: [],
      categoryList : [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangee = (e) => {
    console.log(e.target.files);
    this.setState({
      [e.target.name]: e.target.files,
    });
  };

  handleChangeeOne = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };



  componentDidMount() {
fetch(`${base_url.base_url}/category/retriveCategoryListForselect`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          categoryList: result.data,
        });
      });
  }




  handleChangePage = (event, newPage) => {};

  handleChangeRowsPerPage = (event) => {};

  autoUpdateFunction = () => {};

  succes = (m) => {
    toast.info(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
     {m}
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };

 

  render() {
    return (
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebarc />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ p: { xs: 1, sm: 3 }, mt: 6 }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
                Products Details
              </Typography>

              <Paper
                elevation={0}
                sx={{
                  height: 50,
                  width: "100%",
                  backgroundColor: "#fff",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 17,
                      fontWeight: "500",
                      paddingLeft: { xs: 1, sm: 2, md: 3 },
                      color: "#666666",
                    }}
                  >
                Add Products
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    mr: { xs: 1, sm: 2, md: 3 },
                  }}
                >
                  <Button
                      onClick={() => this.props.navigate('/productsList')}
                    sx={{
                      textTransform: "none",
                      height: 30,
                      backgroundColor: "#008ffb",
                      fontWeight: "600",
                    }}
                    disableElevation
                    variant="contained"
                    startIcon={<AddIcon sx={{ color: "#fff" }} />}
                  >
                    Product List
                  </Button>
                </Box>
              </Paper>

              <Paper
                elevation={0}
                sx={{ width: "100%", minHeight: 200, mt: 2 }}
              >
                <Box sx={{ p: 2 }}>
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Product Name{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="product_name"
                        value={this.state.product_name}
                        onChange={this.handleChange}
                        inputProps={{ sx: { fontSize: 13, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Price{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="price"
                        value={this.state.price}
                        onChange={this.handleChange}
                        inputProps={{ sx: { fontSize: 13, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Unit (examples : 1pcs, 5 gram, 2 kg etc)
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        type="text"
                        size="small"
                        name="weight"
                        value={this.state.weight}
                        onChange={this.handleChange}
                        inputProps={{ sx: { fontSize: 13, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Products category{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="product_type"
                        value={this.state.product_type}
                        onChange={this.handleChange}
                        inputProps={{ sx: { fontSize: 12, fontWeight: "600" } }}
                        select
                        defaultValue={this.state.product_type}
                        fullWidth
                      >
                        {this.state.categoryList.map((option) => (
                          <MenuItem
                            onClick={() =>
                              this.setState({ product_type: option.category_name })
                            }
                            key={option.category_name}
                            sx={{ fontSize: 11, fontWeight: "600" }}
                            value={option.category_name}
                          >
                            {option.category_name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid2>

           
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Product description{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="product_description"
                        value={this.state.product_description}
                        onChange={this.handleChange}
                        multiline
                        rows={3}
                        placeholder="Description"
                        defaultValue=""
                        inputProps={{ sx: { fontSize: 12, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Thumbnail image{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <input
                        name="thumb_nail_img"
                        onChange={this.handleChangeeOne}
                        accept=".jpg,.jpeg,.png,.webp"
                        type="file"
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Product images(Minimum 3 image required)
                        
                                                <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <input
                        multiple
                        name="productImage"
                        onChange={this.handleChangee}
                        accept=".jpg,.jpeg,.png,.webp"
                        type="file"
                      />
                    </Grid2>
                  </Grid2>
                  <br />
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      let formData = new FormData();
                      formData.append("product_name", this.state.product_name);
                      formData.append(
                        "product_description",
                        this.state.product_description
                      );
                      formData.append("weight", this.state.weight);
                      formData.append("metal_type", this.state.metal_type);
                      formData.append("product_type", this.state.product_type);
                      formData.append('price',this.state.price)
                      formData.append(
                        "thumb_nail_img",
                        this.state.thumb_nail_img
                      );
                      for (
                        let index = 0;
                        index < this.state.productImage.length;
                        index++
                      ) {
                        formData.append(
                          "productImage",
                          this.state.productImage[index]
                        );
                      }

                      if (
                        this.state.product_name !== "" &&
                        this.state.product_type !== "" &&
                        this.state.product_description !== "" &&
                        this.state.weight !== "" &&
                        this.state.productImage.length > 0 &&
                        this.state.thumb_nail_img !== "" && 
                        this.state.price!==0
                      ) {
                        fetch(`${base_url.base_url}/product/addProduct`, {
                          /*
  headers: {
    "content-type": "application/json",
  },
  */
                          method: "post",
                          body: formData,
                        })
                          .then((res) => {
                            return res.json();
                          })
                          .then((result) => {
                          this.succes('Products details uploaded sucessfull')
                          });
                      } else {
                        this.succes('Fill all fields')
                      }
                    }}
                  >
                    Submit
                  </Button>
                  <br />
                </Box>
              </Paper>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              position: "fixed",
              top: 0,
              left: { xs: 0, sm: 240 },
            }}
          >
            <Appheaderc />
          </Box>
        </Box>

        {
          //////// add userDtata data
        }

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    );
  }
}

export default AddProducts;
